import { Paper, Stack, Skeleton, Divider, Box } from '@mui/material';

const ActivityNoteDetailsSkeleton = () => {
  return (
    <Box sx={{ width: "100%", marginTop: 4 }}>
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2, width: "100%" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{ flex: 1 }}
          >
            <Skeleton variant="text" width={300} height={32} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={60} height={24} />
              <Skeleton variant="rounded" width={80} height={24} />
              <Skeleton variant="rounded" width={70} height={24} />
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rectangular" width={40} height={32} />
            <Skeleton variant="rectangular" width={100} height={32} />
          </Stack>
        </Stack>
        
        <Stack direction="row" spacing={3} flexWrap="wrap" mb={2} alignItems="center">
          <Skeleton variant="text" width={150} height={20} />
          <Skeleton variant="text" width={120} height={20} />
          <Stack direction="row" alignItems="center" spacing={1}>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={100} height={20} />
          </Stack>
          <Skeleton variant="text" width={100} height={20} />
        </Stack>
        
        <Divider sx={{ mb: 2 }} />
        
        <Stack spacing={1}>
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="70%" height={20} />
        </Stack>
      </Paper>
    </Box>
  );
};

export default ActivityNoteDetailsSkeleton;
